import React from 'react';
import Localization from '../../Localization';

import './styles.scss';

const geoOptions = [
  {
    key: 'countries',
    label: 'Country',
  },
  {
    key: 'regions',
    label: 'Region',
  },
];

export default function Form(props) {
  const { regions, selected, maxSelected, toggleGeo, geoType, setGeoType, setReport } = props;
  const isRegion = geoType === 'regions';
  const language = Localization.getLanguage();

  return (
    <div className='Form'>
      <div className='instructions'>
        {Localization.get('multiAttributeCopy')}
      </div>
      <div className='selector'>
        <div className='bigLabel'>
          {Localization.get('Choose a Modifier')}
        </div>
        <div className='tabs'>
          {geoOptions.map(g => (
            <div
              key={g.key}
              className={`option ${g.key === geoType ? 'active' : ''}`}
              onClick={() => setGeoType(g.key)}
            >
              <div className='label'>
                {Localization.get(g.label)}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='options'>
        <div className='bigLabel'>
          {Localization.get(`Choose up to ${maxSelected}`)}
        </div>
        <div className={`checkboxes ${isRegion ? 'compact' : ''}`}>
          {regions.map(r => (
            <div key={r.key} className='regions'>
              <div
                className='toggle region'
                onClick={() => isRegion ? toggleGeo(r.key) : null}
              >
                <input
                  type='checkbox'
                  id={`toggle-${r.key}`}
                  name={`toggle-${r.key}`}
                  checked={selected.includes(r.key)}
                  className={isRegion ? '' : 'hidden'}
                  readOnly
                />
                <label htmlFor={`toggle-${r.key}`}>
                  {language === 'zh' ? Localization.get(r.key.toUpperCase()) : r.key}
                </label>
              </div>
              <div className='countries'>
                {isRegion ? null : (
                  r.countries.map(c => (
                    <div
                      key={c.id}
                      className='toggle country'
                      onClick={() => toggleGeo(c.name)}
                    >
                      <input
                        type='checkbox'
                        id={`toggle-${c.id}`}
                        name={`toggle-${c.id}`}
                        checked={selected.includes(c.name)}
                        readOnly
                      />
                      <label htmlFor={`toggle-${c.id}`}>
                        {language === 'zh' ? Localization.get(c.name.toUpperCase()) : c.name}
                      </label>
                    </div>
                  ))
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        className={`button ${selected.length > 0 ? '' : 'inactive'}`}
        onClick={() => {
          if (selected.length > 0) {
            window.scrollTo(0, 0);
            setReport(true);
          }
        }}
      >
        <button>
          {Localization.get('Generate Report')}
        </button>
      </div>
    </div>
  )
}
